import * as React from 'react';
import ConsoleLayout from '../Console/ConsoleLayout';
import './LicenseManagerLayout.css';

class LicenseManagerLayout extends React.Component<any, any> {
    public render() {
        return (
            <ConsoleLayout>
                {this.props.children}
            </ConsoleLayout>
        );
    }
}

export default LicenseManagerLayout;
